<template>
  <section>
    <div>
      <div>
        <h1>Oh no! Anyway...</h1>
        <p>
          Looks like this page doesn't exist.
          <router-link to="/">
            Click here to return to the homepage.
          </router-link>
        </p>
      </div>
    </div>
  </section>
</template>
